// extracted by mini-css-extract-plugin
export default {"body":"confirm-modal_body__eDz4H","text":"confirm-modal_text__N7iG5","actions":"confirm-modal_actions__6XZar"};